import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SucursalesService } from 'src/app/core/http/web/sucursales.service';
import { environment as params } from 'src/environments/environment';
import { SucMapComponent } from '../componets/suc-map/suc-map.component';
import { ScrollAppService } from 'src/app/core/services/utilities/scroll.service';

@Component({
  selector: 'app-home-sucursales',
  templateUrl: './home-sucursales.component.html',
  styleUrls: ['./home-sucursales.component.scss']
})
export class HomeSucursalesComponent {
  public route: string;
  public orden: any = null;
  public objectValues = Object.values;
  public dataPage: any = null;
  public errors: any;
  public loadPerParts: boolean;
  public loadings: any = true;
  public dataFiltred: any;
  public dataMaps: any;
  public km: number;
  urlBaseS3: any = (<any>params).api.s3;
  public optionsPage: any = null;
  @ViewChild(SucMapComponent) childPrice: SucMapComponent;
  constructor(
    private titleService: Title,
    private _route: Router,
    private sucWpServ: SucursalesService,
    private scrollServ: ScrollAppService
  ) {
    this.titleService.setTitle('Sucursales | Mundo Joven 2019');
    this.route = _route.url.slice(1);
    this.route = this.route.split('?')[0];
    this.getOptions();
    this.getDataSucursales();
  }

  getDataSucursales() {
    this.sucWpServ.getAllData().subscribe(data => {
      const nData = data.sucursales.map(e => {
        const newE = e;
        newE.collapse = true;
        newE.latitud = Number(e.latitud);
        newE.longitud = Number(e.longitud);
        return newE;
      });
      this.dataPage = nData;
      this.filterData();
      this.loadings = false;
    }, err => {
      console.error('Error | getDataAllSucursales: ', err);
      this.loadPerParts = true;
      this.errors = err;
    });
  }
  getOptions() {
    this.sucWpServ.getOptions().subscribe(data => {
      this.optionsPage = data.general_options;
      console.log('Datos en sucursales', data);
      // this.loadings = false;
    }, err => {
      console.error('Error | getDataAllSucursales: ', err);
    });
  }
  filterData(params: any = {}) {
    this.dataFiltred = this.dataMaps = [];
    if (params.distance && params.lat && params.lon) {
      this.km = params.distance;
      this.dataFiltred = this.dataMaps = this.dataPage.filter(f => {
        const km = this.getKilometros(params.lat, params.lon, f.latitud, f.longitud);
        if (km <= params.distance) {
          return true;
        }
        return false;
      });
      this.scrollServ.scrollToId('map_sucursales', 0, 1000);
    } else {
      this.dataFiltred = this.dataMaps = this.dataPage;
      this.km = 500;
    }
  }
  sucSelected(data) {
    this.dataMaps = [data];
    this.km = 0;
    this.scrollServ.scrollToId('map_sucursales', 0, 1000);
  }
  reload() {
    this.loadings = true;
    this.getDataSucursales();
  }
  // Funcion para calcular kilometros entre dos puntos
  getKilometros(lat1, lon1, lat2, lon2) {
    const rad = function(x) { return x * Math.PI / 180; };
    const R = 6378.137; // Radio de la tierra en km
    const dLat = rad( lat2 - lat1 );
    const dLong = rad( lon2 - lon1 );
    const a = Math.sin(dLat / 2) *
              Math.sin(dLat / 2) +
              Math.cos(rad(lat1)) *
              Math.cos(rad(lat2)) *
              Math.sin(dLong / 2) *
              Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt( 1 - a));
    const d = R * c;
    return d.toFixed(3); // Retorna tres decimales
  }
}
